type Option = {
  label: string
  value: string
}

interface PrependBlankOptionConfig {
  blankOption?: Option
  labelKey?: string
  valueKey?: string
}

function prependBlankOption(
  options: Option[] | null | undefined,
  config: PrependBlankOptionConfig = {}
): Option[] {
  const { blankOption, labelKey = 'label', valueKey = 'value' } = config
  const safeOptions = Array.isArray(options) ? options : []

  const defaultBlank = { [labelKey]: '', [valueKey]: '' }
  const blank = { ...defaultBlank, ...blankOption }

  const alreadyHasBlank = safeOptions.some(
    (opt) => opt[valueKey] === blank[valueKey]
  )
  return alreadyHasBlank ? safeOptions : [blank, ...safeOptions]
}

export default prependBlankOption
